import React from "react";
import { GoToOrdersCTA, RequestCommissionChangeCTA } from "./ctas";
import { RequestCommissionChangesIA } from "./instantAnswersComponents/orders/RequestCommissionChangesIA";
export var RequestCommissionChanges = function RequestCommissionChanges(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return REQUEST_COMMISSION_CHANGES_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return REQUEST_COMMISSION_CHANGES_DESCRIPTION(context);
    }
  };
};
var REQUEST_COMMISSION_CHANGES_TITLE = function REQUEST_COMMISSION_CHANGES_TITLE(strictLocalize) {
  return strictLocalize({
    id: "ONXiK2",
    defaultMessage: [{
      "type": 0,
      "value": "Request a commission change"
    }]
  });
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize) {
  var _context$brandOrder, _context$brandOrder$b;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  if (brandOrderToken) {
    return RequestCommissionChangeCTA(brandOrderToken, strictLocalize);
  }
  return GoToOrdersCTA(strictLocalize);
};
var REQUEST_COMMISSION_CHANGES_DESCRIPTION = function REQUEST_COMMISSION_CHANGES_DESCRIPTION(context) {
  return /*#__PURE__*/React.createElement(RequestCommissionChangesIA, {
    context: context
  });
};